import useUserAccount from "src/store/userAccountState";
import { anyPass, equals } from "ramda";
import type { Pred } from "ramda";
import chainGet from "src/services/network/chainGet";
import permissions from "src/constants/permissions";

type PermissionKeysType = keyof typeof permissions;
type PerimssionValsType = typeof permissions[PermissionKeysType];

const useIsShowSubscriptionTab = () => {
  const { userAccount } = useUserAccount();

  const permission = chainGet(userAccount?.permission, "limited");

  const permissionLowerCase =
    permission.toLowerCase() as typeof permissions[PermissionKeysType];

  const isShow = anyPass<Pred<PerimssionValsType[]>>([
    equals<PerimssionValsType>(permissions.FULL),
    equals<PerimssionValsType>(permissions.SUPERADMIN),
    equals<PerimssionValsType>(permissions.ACCOUNTADMIN),
  ])(permissionLowerCase);

  return isShow;
};

export default useIsShowSubscriptionTab;
